import React from "react"
import { usePage } from "@inertiajs/react"
import { PageSecondaryHeader } from "@kit/design/page-secondary-header"
import { Link } from "core/link"

export const ORIGINS = {
  broadcasts: { href: "/campaigns", label: "Broadcasts" },
  sequences: { href: "/sequences", label: "Email Sequences" },
  rss: { href: "/feeds", label: "RSS" }
}

// Parent breadcrumb for pages reachable from multiple places (e.g. email
// templates, snippets). The `origin` query param names where the user
// navigated from; values outside the allowlist render nothing, same as no
// origin at all.
export function PageHeaderOriginBreadcrumb(props) {
  const { url } = usePage()
  const origin = new URLSearchParams(url.split("?")[1]).get("origin")

  if (!Object.hasOwn(ORIGINS, origin)) return null

  const { href, label } = ORIGINS[origin]

  return (
    <PageSecondaryHeader.Breadcrumb
      {...props}
      href={href}
      render={<Link href={href} />}
    >
      {label}
    </PageSecondaryHeader.Breadcrumb>
  )
}
